import {Model} from '@vuex-orm/core'
import Roomtype from '@models/helpers/Roomtype'
import RoomtypeAt from '@models/helpers/RoomtypeAt'
import Roomltm from '@models/helpers/Roomltm'
import RoomltmAt from '@models/helpers/RoomltmAt'
import Roomairvolume from '@models/airvolumes/Roomairvolume'
import pageValidation from '@services/validations/pageValidation'
import Valve from '@models/airvolumes/Valve'
import Unit from '@models/building/Unit'
import RoomtypesHasLtmsHasOperationmodesHasDevicepackage
  from '@models/helpers/RoomtypesHasLtmsHasOperationmodesHasDevicepackage'
import RoomtypesHasLtmsHasOperationmodesHasDevicepackageAt
  from '@models/helpers/RoomtypesHasLtmsHasOperationmodesHasDevicepackage'
import store from '@store'
import StoredRoomArticle from '@models/articles/StoredRoomArticle'

export default class Room extends Model {
  static entity = 'rooms'

  static fields() {
    return {
      id: this.uid(),
      unitId: this.attr(null),

      storey: this.number(1),
      level: this.number(null).nullable(),
      type: this.number(null).nullable(),
      description: this.string(null).nullable(),
      airType: this.number(null).nullable(),
      ventilationMeasure: this.number(null).nullable(),
      window: this.boolean(null).nullable(),
      length: this.number(null).nullable(),
      width: this.number(null).nullable(),
      height: this.number(2.5),
      space: this.number(null).nullable(),
      volume: this.number(null).nullable(),

      airvolume: this.hasOne(Roomairvolume, 'roomId'),
      valves: this.hasMany(Valve, 'roomId'),

      unit: this.belongsTo(Unit, 'unitId'),
      articles: this.hasMany(StoredRoomArticle, 'room_id'),

      controllingCombo: this.attr(null).nullable(),

      deviceType: this.attr(0),
      deviceInstallation: this.attr(4),

      articleStatus: this.attr('create'),
      articleUpdate: this.attr(true),
      equipmentUpdate: this.attr(true),
      equipmentAccessorygroups: this.attr([]),

      mountingPosition: this.number(12).nullable(),
    }
  }

  static afterUpdate(model) {
    if (store.state.navigation.value.index <= 2) pageValidation.validatePossiblePages()
  }

  static afterCreate(model) {
    if (store.state.navigation.value.index <= 2) pageValidation.validatePossiblePages()
  }

  static beforeDelete(model) {
    if (model.unitId) {
      Unit.update({
        where: model.unitId,
        data: {
          articleStatus: 'create',
          calculationStatus: true,
        },
      })
    }
  }

  setDefaultsByType() {
    // check if type is set
    if (this.type == null) return

    var roomtype = this.getRoomtype()
    //this.door_leaf = roomtype.door_width
    this.airType = roomtype.air_type
    this.window = roomtype.default_window == 1
  }

  setDefaultsByTypeAt() {
    // check if type is set
    if (this.type == null) return

    var roomtype = this.getRoomtypeAt()
    this.airType = roomtype.air_type
  }

  setStorey(storey, level) {
    this.storey = storey
    this.level = level
  }

  resetLevel() {
    if (this.storey != 2) this.level = null
  }

  setSpace() {
    if (isNaN(parseFloat(this.length)) || this.length <= 0) {
      this.length = null
      return
    }
    if (isNaN(parseFloat(this.width)) || this.width <= 0) {
      this.width = null
      return
    }

    this.length = +parseFloat(this.length).toFixed(2)
    this.width = +parseFloat(this.width).toFixed(2)
    this.space = +parseFloat(this.length * this.width).toFixed(2)
    this.setVolume()
  }

  setVolume() {
    if (isNaN(parseFloat(this.space))) {
      this.space = null
      this.volume = null
      return
    }
    if (isNaN(parseFloat(this.height))) {
      this.height = null
      this.volume = null
      return
    }
    this.space = +parseFloat(this.space).toFixed(2)
    this.height = +parseFloat(this.height).toFixed(2)
    this.volume = +parseFloat(this.space * this.height).toFixed(2)
  }

  validation() {
    if (this.type == null || this.type <= 0) return false
    if (this.volume == null || this.volume <= 0) return false
    if (this.space == null || this.space <= 0) return false
    if (this.height == null || this.height <= 0) return false
    if (this.type == null || this.type == '') return false
    if (this.airType == null || this.airType == '') return false
    if (this.ventilationMeasure == null) return false
    return true
  }

  getRoomtype() {
    return Roomtype.find(this.type)
  }

  getRoomtypeAt() {
    return RoomtypeAt.find(this.type)
  }

  getRoomtypeAirvolume() {
    var roomtype = this.getRoomtype()
    if (this.window == 1) return parseFloat(roomtype.air_volume_red_with_window)
    else return parseFloat(roomtype.air_volume_red_without_window)
  }

  getAldAirvolume(insulation) {
    var roomtype = this.getRoomtype()
    if (insulation == 1) return parseFloat(roomtype.au_volume_insulation_high)
    else return parseFloat(roomtype.au_volume_insulation_low)
  }

  getRoomtypeDoorLeaf() {
    var roomtype = this.getRoomtype()
    return roomtype.door_width
  }

  getRoomltm() {
    return Roomltm.find(this.ventilationMeasure)
  }

  getRoomltmAt() {
    return RoomltmAt.find(this.ventilationMeasure)
  }

  getDevicePackage() {
    return RoomtypesHasLtmsHasOperationmodesHasDevicepackage.query()
      .where((query) => {
        return this.unit.ventilationMeasure == query.ltms_id && this.ventilationMeasure == query.roomltms_id && this.airvolume.operationmodeAirvolume == query.roomtypes_has_operationmodes_has_airvolumes_id
      })
      .first()
  }


  getDevicePackageAt() {
    return RoomtypesHasLtmsHasOperationmodesHasDevicepackageAt.query()
      .where((query) => {
        return this.unit.ventilationMeasure == query.ltms_id && this.ventilationMeasure == query.roomltms_id && this.airvolume.operationmodeAirvolume == query.roomtypes_has_operationmodes_has_airvolumes_id
      })
      .first()
  }

  getPipeAmmount() {
    var quantity = 0
    this.valves.forEach((valve) => {
      quantity += valve.pipesAmmount
    })
    return quantity
  }

  deleteArticles() {
    StoredRoomArticle.delete((article) => {
      return article.room_id == this.id
    })
  }

  deleteAirvolumes() {
    Roomairvolume.delete((airvolume) => {
      return airvolume.roomId == this.id
    })
  }
}
